// extracted by mini-css-extract-plugin
export var text = "authorOneLine-module--text--3cef4";
export var textLink = "authorOneLine-module--textLink--0dee6";